export default __webpack_public_path__ + "fonts/basis-grotesque-bold-pro.woff2";